import { DocumentType } from "../IDPForgeryCheck/types";

export enum DocumentDatabaseStatus {
  AVAILABLE = "AVAILABLE",
  UNREADABLE = "UNREADABLE",
  PROCESSING = "PROCESSING",
  FAILED = "FAILED",
}

export interface DocumentDatabaseEntry {
  id: number;
  requestDate: string;
  documentType: DocumentType;
  companyName: string;
  companySector?: string | null;
  companySubSector?: string | null;
  processingTime?: number | null;
  status: DocumentDatabaseStatus;
  fileSize?: number;
  processedAt?: string;
  createdAt: string;
  updatedAt: string;
  sector: string;
  subSector: string;
}

export interface DocumentDatabaseResponse {
  data: DocumentDatabaseEntry[];
  total: number;
  page: number;
  limit: number;
}
